import React from 'react';
import ServiceCard from '../ServiceCard';
import CompactServiceRows from '../service-listings/CompactServiceRows';
import { SERVICE_LISTING_STYLE_OPTIONS } from '../../utils/landingPageTheme';

const StorefrontServiceSection = ({
  services = [],
  serviceListingStyle,
  onServiceClick
}) => (
  <section className="services-section storefront-services-section" id="storefront-services">
    <div className="container">
      {services.length === 0 ? (
        <div className="no-services storefront-empty-state">
          <p>No services available at this time.</p>
        </div>
      ) : serviceListingStyle === SERVICE_LISTING_STYLE_OPTIONS.COMPACT_ROWS ? (
        <CompactServiceRows
          services={services}
          onServiceClick={onServiceClick}
        />
      ) : (
        <div className="services-grid">
          {services.map((service) => (
            <ServiceCard
              key={service.id}
              service={service}
              onClick={() => onServiceClick(service)}
            />
          ))}
        </div>
      )}
    </div>
  </section>
);

export default StorefrontServiceSection;
